var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterTopRight(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 300,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.9 0h199.8v199.8H99.9zM0 0h99.9v99.9H0zM199.8 199.8h99.9v99.9h-99.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199.7 0v50h50v50h50V0h-100z",
    fill: "#8E75FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M249.7 50.001h-49.81v50.098h49.81V50.001z",
    fill: "#D2C7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249.7 100.099h-49.81v50.097h49.81v-50.097z",
    fill: "#EBF4FD",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M299.7 150.196h-49.8v50.098h49.8v-50.098zM99.89 100.099h-49.8v50.097h49.8v-50.097z",
    fill: "#EBF4FD",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.7 0H99.89v50.098h49.81V0z",
    fill: "#EBF4FD",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M199.7 50h-50l50-50v50zM249.4 150v-50h50l-50 50z",
    fill: "#D2C7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTopRight);
export default "/_next/static/images/05cae2bf306c44b4a82fda253514822e.svg";
export { ForwardRef as ReactComponent };